import React from 'react';
import { Calendar, BarChart3 } from 'lucide-react';

const AnalyticsSessions = ({
  analyticsHistory,
  loadingHistory,
  getRecentSessions,
  loadAnalyticsHistory,
  createSampleAnalytics,
  openSessionModal,
  processEnv
}) => (
  <div className="mt-6 sm:mt-8 bg-white rounded-xl sm:rounded-2xl shadow-sm border border-gray-200">
    <div className="p-4 sm:p-6 border-b border-gray-200">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0">
        <div>
          <h3 className="text-base sm:text-lg font-semibold text-gray-900">Recent Analytics Sessions</h3>
          <p className="text-xs sm:text-sm text-gray-500 mt-1">
            {loadingHistory ? 'Loading...' : `${analyticsHistory.length} total events recorded`}
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
          {processEnv === 'development' && (
            <button
              onClick={createSampleAnalytics}
              className="inline-flex items-center justify-center px-3 py-1.5 bg-green-500 text-white rounded-lg text-xs sm:text-sm hover:bg-green-600 transition-colors w-full sm:w-auto"
            >
              Create Sample Data
            </button>
          )}
          <button
            onClick={loadAnalyticsHistory}
            disabled={loadingHistory}
            className="inline-flex items-center justify-center px-3 py-1.5 bg-blue-500 text-white rounded-lg text-xs sm:text-sm hover:bg-blue-600 disabled:opacity-50 transition-colors w-full sm:w-auto"
          >
            {loadingHistory ? 'Loading...' : 'Refresh'}
          </button>
        </div>
      </div>
    </div>
    <div className="p-4 sm:p-6">
      {getRecentSessions().length === 0 ? (
        <div className="text-center py-6 sm:py-8">
          <Calendar className="w-10 h-10 sm:w-12 sm:h-12 text-gray-300 mx-auto mb-3 sm:mb-4" />
          <h4 className="text-base sm:text-lg font-medium text-gray-900 mb-1 sm:mb-2">No Sessions Yet</h4>
          <p className="text-xs sm:text-sm text-gray-500">
            Analytics sessions will appear here after users interact with your pitch deck.
          </p>
        </div>
      ) : (
        <div className="space-y-3 sm:space-y-4">
          {getRecentSessions().map((session, index) => (
            <div
              key={session.sessionId}
              className="border border-gray-200 rounded-lg sm:rounded-xl p-3 sm:p-4 hover:shadow-md transition-shadow cursor-pointer"
              onClick={() => openSessionModal(session)}
            >
              <div className="flex items-center gap-2 text-blue-600 hover:text-blue-700">
                <BarChart3 className="w-4 h-4" />
                <span className="text-xs sm:text-sm font-medium">View Details</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  </div>
);

export default AnalyticsSessions; 